<template>
  <div class="project-add-container">
    <InfoContainer
      :infoTitle="InfoContainerConfig.infoTitle"
      :contentConfig="InfoContainerConfig.infoContent"
    >
      <template #basicInfo>
        <avue-form
          ref="basicInfo"
          v-model="basicInfoData"
          :option="addConfig"
        >
          <!-- 债权人和债务人选择 -->
          <template #sellerCustId>
            <CommonSelect
              bindLabel="custName"
              searchKey="custName"
              bindKey="id"
              bindValue="custName"
              methods="get"
              dataMethod="params"
              dataUrl="bl/custbasicinformationbl/page"
              :bindId="basicInfoData.sellerCustId?basicInfoData.sellerCustId:''"
              @handleChange="setSellerCustId"
            />
          </template>
          <template #projectTranslation>
            <div class="project-block" style="border: 1px solid #ccc;">
              <Toolbar
                  style="border-bottom: 1px solid #ccc"
                  :editor="editor"
                  :defaultConfig="toolbarConfig"
                  mode="default"
              />
              <Editor
                  style="height: 200px; overflow-y: hidden;"
                  v-model="basicInfoData.projectTranslation"
                  :defaultConfig="editorConfig"
                  mode="default"
                  @onCreated="onCreated"
              />
            </div>
          </template>
        </avue-form>
        <div class="submit-con">
          <el-button type="primary" @click="validData()">保存</el-button>
          <!-- <el-button type="primary" plain @click="validData(true)" v-if="!$route.params.id">发起流程</el-button> -->
        </div>               
      </template>
    </InfoContainer>

    <SelectPerson
        ref="selectperson"
        :checkUserList="checkUserList"
        :isOnly="true"
        :clear="false"
        @setPeople="setPeople"
    />

  </div>
</template>
<script>
import CommonSelect from "@/components/commonSelect/commonSelect"
import InfoContainer from "@/components/infoContainer/infoContainer";
import CommentBlock from "@/components/workflowComponents/commentBlock/commentBlock";
import { projectAddConfig } from './projectConfig'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import {addFactoringProject} from "@/api/factoring/factoring"
import SelectPerson from "@/components/SelectPersonnel/person";
import { mapGetters } from "vuex";
export default {
  name: 'FactoringProjectAdd',
  data() {
    return {
      addConfig: projectAddConfig(this.selectPersonClick),
      checkUserList: [],
      basicInfoData: {
        managerUserName: ''
      },
      editor: null,
      toolbarConfig: { },
      editorConfig: { placeholder: '请输入内容...' },
      InfoContainerConfig: {
        infoTitle: '新建项目',
        infoContent: [{
          title: '基础信息',
          prop: 'basicInfo'
        }]
      }      
    }
  },
  computed: {
    ...mapGetters(["userInfo"]),
    //   权限
  },  
  components: {
    SelectPerson,
    InfoContainer,
    CommentBlock,
    CommonSelect,
    Editor,
    Toolbar
  },
  mounted() {
    this.basicInfoData.managerUserName = this.userInfo.nick_name
    this.basicInfoData.managerUser = this.userInfo.user_id
  },
  beforeDestroy() {
      const editor = this.editor
      if (editor == null) return
      editor.destroy() // 组件销毁时，及时销毁编辑器
  },
  methods: {
    selectPersonClick() {
      this.$refs.selectperson.showmode();
    },

    setPeople(val) {
      this.checkUserList = val;
      // this.getVisitPeople();
      let people = val.map((item) => {
          return item.realName;
      });
      let ids = val.map((item) => {
          return item.id;
      });
      this.basicInfoData.assistUserName = people.join(',')
      this.basicInfoData.assistUser = ids.join(',')
    },

    onCreated(editor) {
      this.editor = Object.seal(editor)
    },
    setSellerCustId(data) {
      this.basicInfoData.sellerCustId = data.id
      this.basicInfoData.sellerCustName = data.custName
    },
    validData() {
      let self = this
      this.$refs.basicInfo.validate((valid, done) => {
        if(valid) {
          // 校验通过, 提交数据
          self.submitForm()
          done()
        }
      })      
    },

    async submitForm() {
      let params = {
        ...this.basicInfoData
      }
      let res = await addFactoringProject(params)
      if(res.data.code == 200){
        this.$message({
          type: "success",
          message: "新增成功"
        })
        this.$router.go(-1)
      }else {
        this.$message.error(res.data.msg);
      }
    }

  }
}
</script>
<style src="@wangeditor/editor/dist/css/style.css"></style>
<style lang="scss" scoped>
.project-add-container{
  .submit-con{
    text-align: center;
    margin-bottom: 40px;
    button{
      width: 150px;
    }
  }  
}
</style>